import _extends from "@babel/runtime/helpers/extends";
import * as React from "react";
import { forwardRef } from "react";
const SvgComponent = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 20 20",
  ref: ref
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "#E9E3FD",
  d: "m3.2 9.99 2.696 2.242L8.59 9.99 5.896 7.748zm8.247 0 2.695 2.242 2.696-2.242-2.696-2.242zM6.949 6.242l2.695 2.241 2.696-2.241L9.644 4zm0 7.496 2.695 2.242 2.696-2.242-2.696-2.241z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#5B2CE8",
  fillRule: "evenodd",
  d: "M9.552 3.543a.7.7 0 0 1 .896 0l2.737 2.276a.7.7 0 0 1 0 1.077l-2.737 2.276a.7.7 0 0 1-.896 0L6.815 6.896a.7.7 0 0 1 0-1.077zM8.357 6.358 10 7.724l1.643-1.366L10 4.992zm-3.367.827a.7.7 0 0 1 .895 0l2.738 2.277a.7.7 0 0 1 0 1.076l-2.738 2.277a.7.7 0 0 1-.895 0l-2.738-2.277a.7.7 0 0 1 0-1.076zm9.125 0a.7.7 0 0 1 .895 0l2.738 2.277a.7.7 0 0 1 0 1.076l-2.738 2.277a.7.7 0 0 1-.895 0l-2.738-2.277a.7.7 0 0 1 0-1.076zM3.795 10l1.643 1.366L7.08 10 5.438 8.634zm9.125 0 1.643 1.366L16.205 10l-1.642-1.366zm-6.105 3.104 2.737-2.276a.7.7 0 0 1 .896 0l2.737 2.276a.7.7 0 0 1 0 1.077l-2.737 2.276a.7.7 0 0 1-.896 0l-2.737-2.276a.7.7 0 0 1 0-1.077m1.542.538L10 15.01l1.643-1.367L10 12.276z",
  clipRule: "evenodd"
}));
const ForwardRef = /*#__PURE__*/forwardRef(SvgComponent);
export default ForwardRef;
//# sourceMappingURL=WorkAppColorIcon20.js.map